import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-recibo',
  templateUrl: './recibo.component.html',
  styleUrls: ['./recibo.component.css']  
})

export class ReciboComponent implements OnInit {
  
  public empresa: string = '';
  public funcionario: string = '';
  public dateObj = new Date();
  public month = this.dateObj.getUTCMonth() + 1; //months from 1-12
  public day = this.dateObj.getUTCDate();
  public year = this.dateObj.getUTCFullYear();
  public mesConvertido = this.month.toString().length == 1 ? '0' + this.month.toString() : this.month.toString();
  
  public periodo = this.mesConvertido + '/' + this.year;

  public hora50: string = '';
  public minuto50: string = '';
  public hora80: string = '';
  public minuto80: string = '';
  public hora100: string = '';
  public minuto100: string = '';
  public hora120: string = '';
  public minuto120: string = '';
  public horaFeriado: string = '';
  public minutoFeriado: string = '';
  public diasTrabalhado: string = '';
  
  public valorTotal50: number = 0;
  public valorTotal80: number = 0;
  public valorTotal100: number = 0;
  public valorTotal120: number = 0;
  public valorTotalFeriado: number = 0;
  public valorTotalDsr: number = 0;
  public valorTotalDiasSalario: number = 0;
  public valorTotalPagamento: number = 0;

  constructor(private route: ActivatedRoute) { }


  ngOnInit() {
    this.route.params.subscribe(parametros => {
      this.empresa = parametros.razaoSocial
      this.funcionario = parametros.funcionario
      this.hora50 = parametros.hora50.length == 1 ? '0' + parametros.hora50 : parametros.hora50
      this.hora80 = parametros.hora80.length == 1 ? '0' + parametros.hora80 : parametros.hora80
      this.hora100 = parametros.hora100.length == 1 ? '0' + parametros.hora100 : parametros.hora100
      this.hora120 = parametros.hora120.length == 1 ? '0' + parametros.hora120 : parametros.hora120
      this.horaFeriado = parametros.horaFeriado.length == 1 ? '0' + parametros.horaFeriado : parametros.horaFeriado
      this.minuto50 = parametros.minuto50.length == 1 ? '0' + parametros.minuto50 : parametros.minuto50
      this.minuto80 = parametros.minuto80.length == 1 ? '0' + parametros.minuto80 : parametros.minuto80
      this.minuto100 = parametros.minuto100.length == 1 ? '0' + parametros.minuto100 : parametros.minuto100
      this.minuto120 = parametros.minuto120.length == 1 ? '0' + parametros.minuto120 : parametros.minuto120
      this.minutoFeriado = parametros.minutoFeriado.length == 1 ? '0' + parametros.minutoFeriado : parametros.minutoFeriado
      this.valorTotal50 = parametros.vTotal50
      this.valorTotal80 = parametros.vTotal80
      this.valorTotal100 = parametros.vTotal100
      this.valorTotal120 = parametros.vTotal120
      this.valorTotalFeriado = parametros.vTotalFeriado
      this.valorTotalDsr = parametros.vTotalDsr
      this.valorTotalPagamento = parametros.vTotal
      this.diasTrabalhado = parametros.diasTrabalhado
      this.valorTotalDiasSalario = parametros.vTotalDiasSalario
    });
  }
}
